import React, { useState, useEffect } from 'react'
import { getCateringProvidersByEventLocation } from '../../../Apiservices/Auth/servers/fetchProviderData'
import ProviderListWithPagination from '../ProviderListWithPagination';

function Cateringlistofprovider({ longitude, latitude, eventTypeId, eventDetails }) {
  const [loading, setLoading] = useState(true);
  const [providers, setProviders] = useState([]);
  const [error, setError] = useState(null);

  const fetchcateringdata = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await getCateringProvidersByEventLocation(
        longitude, latitude, eventTypeId
      );
      
      console.log("Raw API response:", res);
      
      if (res && res.data && Array.isArray(res.data)) {
        // Filter providers that have items with non-empty includedItems
        const filteredProviders = res.data.filter(provider => {
          // Check if provider has items array
          if (!provider.items || !Array.isArray(provider.items)) {
            return false;
          }
          
          // Filter items to keep only those with non-empty includedItems
          const validItems = provider.items.filter(item => 
            item.includedItems && 
            Array.isArray(item.includedItems) && 
            item.includedItems.length > 0
          );
          
          // Update provider's items with only valid ones
          provider.items = validItems;
          
          // Return true if provider has at least one item with non-empty includedItems
          return validItems.length > 0;
        });
        
        console.log(`Filtered ${filteredProviders.length} providers with non-empty includedItems`);
        console.log("Filtered providers:", filteredProviders);
        
        setProviders(filteredProviders);
      } else {
        console.warn("No valid data received from API");
        setProviders([]);
      }
    } catch (error) {
      console.error("Error fetching catering providers:", error);
      setError("Failed to load catering providers");
      setProviders([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchcateringdata();
  }, [longitude, latitude, eventTypeId]);



  return (
    <>
      {loading ? (
        <div style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          height: "200px" 
        }}>
          <h3 style={{ margin: 0 }}>
            <i 
              className="pi pi-spin pi-spinner-dotted" 
              style={{ fontSize: "2rem", color: "#0cc0df" }}
            ></i>
          </h3>
        </div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : providers.length === 0 ? (
        <div className="no-providers-message">
          No catering providers with menu items found for this event.
        </div>
      ) : (
        <>
          {/* <div style={{ 
            marginBottom: '10px', 
            color: '#000000ff',
            padding: '10px',   
            fontSize:"20px",
            borderRadius: '4px'
          }}>
            Found {providers.length} catering providers with complete menu information.
            {providers.length > 0 && 
              ` Showing ${providers.reduce((total, p) => total + (p.items?.length || 0), 0)} available packages.`
            }
          </div> */}
          <ProviderListWithPagination
            items={providers}
            id={9}
            eventDetails={eventDetails}
            cancallcatering={true}
            quantity={10}
            by={'before list'}
          />
        </>
      )}
    </>
  );
}

export default Cateringlistofprovider;